import Link from 'next/link';
import styled from 'styled-components';
import { Breakpoints } from '../../../../styled/constants';

export const AgencyLink = styled(Link)`
  text-decoration: none;
  display: block;
  width: 100%;
  padding: 15px;
  height: 50px;
  background-color: ${({ theme }) => theme.colors.systemColors.blue};
  text-align: center;
  border-radius: 14px;
  color: ${({ theme }) => theme.colors.text.white};
  margin-top: 15px;
  font-size: 15px;

  @media (min-width: ${Breakpoints.tablet}px) {
    margin-top: 30px;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    margin-top: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.colors.background.primary};
    border: 1px solid ${({ theme }) => theme.colors.border.primary};
    color: ${({ theme }) => theme.colors.systemColors.blue};
  }
`;
